import Image from './image.js';
export default Image;
